import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { replace } from 'connected-react-router';
import {
  createOrderRequest,
  initOrderRequest,
  resetCurrentOrder,
} from '../../store/modules/orders/actions';
import { useActionDispatcher } from '../../hooks';
import { isOrderPersistent, selectOrder } from '../../store/modules/orders/selectors';
import OrderForm from './OrderForm';

const OrderCreate = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(initOrderRequest());
    return () => {
      dispatch(resetCurrentOrder());
    };
  }, [dispatch]);

  const createOrder = useActionDispatcher(createOrderRequest);
  const persistent = useSelector(isOrderPersistent);
  const order = useSelector(selectOrder);

  useEffect(() => {
    if (persistent) {
      dispatch(replace(`/dashboard/admin/orders/${order.data!.id}`));
    }
  }, [persistent, order.data, dispatch]);

  return (
    <OrderForm
      creatingMode
      record={order}
      onSubmit={createOrder}
    />
  );
};

export default OrderCreate;
